// Rince 3D turntable

function buildRinceTurntable(THREE, renderer, opts) {
  var TH = THREE;
  opts = opts || {};

  /* =====================================================================
     SCALE / PROPORTIONS  (real product 130 x 60 x 340 mm, ~325 g)
     World units: 1 unit ~= 47 mm. Head is a taller-than-wide racetrack
     ~0.60 wide x ~0.84 tall with a TRUE see-through hollow; long slim
     stem below. Whole unit ~3.4 tall  ->  height : head-width ~= 5.7 : 1,
     matching 340 : 60 mm. Model is centred on y~=0 so spin/tilt are clean.
  ===================================================================== */
  // Proportions matched to the real product photos: a BIG hollow oval head
  // (~37% of the height) over a SHORT smooth stem + a knurled connector.
  // Matched to ali_45 (front) + ali_03 (3/4): outer oval W:H ~= 1:1.15 (130 wide),
  // a CHUNKY ring ~60 mm deep (~46% of width), head ~37% of the total length.
  // From the cross-checked photo spec (DJI studio shots + listing):
  //  - vertical obround head, W:H ~= 1:1.38 (130 mm = the SHORT axis)
  //  - chunky ~60 mm depth (depth:width ~0.46)
  //  - BLIND recessed front pocket onto a glass plate; CLOSED domed back (no hole)
  //  - wide FLAT light-grey perforated collar on the front face (not chrome/red)
  var HEAD_HW   = 0.36;   // head half-width (short axis, 130 mm)
  var HEAD_HH   = 0.47;   // head half-height (long axis) — H:W ~1.31 (photo consensus)
  var HEAD_R    = 0.345;  // corner radius — near-FULL stadium (R/HW ~0.96), semicircular
  //   ends. Safe now: the head uses extrudeFlat + obroundFrustum chamfers (no beveled
  //   ring extrude), so a near-stadium radius no longer degenerates any bevel.
  var BODY_DEPTH= 0.33;   // front-to-back depth (~60 mm, matches 130x60 spec)
  // The opening is a SEE-THROUGH hollow (Dyson-style), a tall pill (stadium).
  var HOLE_HW   = 0.180;  // hollow half-width (opening:head width ~0.50)
  var HOLE_HH   = 0.300;
  var HOLE_R    = 0.178;  // ~stadium ends
  var POCKET_DEPTH = 0.125;

  var HEAD_CY   = 0.775;  // head centre (head 0.275 .. 1.275)
  var BASE_Y    = -1.275; // thread tip / ground plane
  var HANDLE_R  = 0.166;  // straight untapered handle radius

  /* =====================================================================
     CANVAS TEXTURE HELPERS  (all procedural — no external assets)
  ===================================================================== */
  var disposables = [];
  function track(o){ if(o) disposables.push(o); return o; }

  function dotBump(px, cols, rows, r, light, dark){           // knurl dot grid
    var c=document.createElement('canvas'); c.width=px; c.height=px;
    var x=c.getContext('2d');
    x.fillStyle=dark||'#1d1d1d'; x.fillRect(0,0,px,px);
    var sx=px/cols, sy=px/rows;
    for(var i=0;i<cols;i++)for(var j=0;j<rows;j++){
      var cx=(i+0.5)*sx + (j%2?sx*0.5:0), cy=(j+0.5)*sy;
      var g=x.createRadialGradient(cx-r*0.3,cy-r*0.3,0,cx,cy,r);
      g.addColorStop(0,light); g.addColorStop(0.6,'#8a8a8a'); g.addColorStop(1,dark||'#1c1c1c');
      x.fillStyle=g; x.beginPath(); x.arc(cx,cy,r,0,Math.PI*2); x.fill();
    }
    var t=new TH.CanvasTexture(c);
    t.wrapS=t.wrapT=TH.RepeatWrapping; t.anisotropy=4; t.needsUpdate=true;
    return track(t);
  }
  function stripeBump(px,n){                                  // thread V-rings
    var c=document.createElement('canvas'); c.width=8; c.height=px;
    var x=c.getContext('2d');
    for(var i=0;i<px;i++){
      var v=Math.round(118+95*Math.sin(i/px*n*Math.PI*2));
      x.fillStyle='rgb('+v+','+v+','+v+')'; x.fillRect(0,i,8,1);
    }
    var t=new TH.CanvasTexture(c);
    t.wrapS=t.wrapT=TH.RepeatWrapping; t.needsUpdate=true;
    return track(t);
  }
  function perfBump(px, cols, rows, r){                       // perforation grid
    var c=document.createElement('canvas'); c.width=px; c.height=px;
    var x=c.getContext('2d');
    x.fillStyle='#c0c0c0'; x.fillRect(0,0,px,px);
    var sx=px/cols, sy=px/rows;
    for(var i=0;i<cols;i++)for(var j=0;j<rows;j++){
      var cx=(i+0.5)*sx + (j%2?sx*0.5:0), cy=(j+0.5)*sy;
      var g=x.createRadialGradient(cx,cy,0,cx,cy,r);
      g.addColorStop(0,'#101010'); g.addColorStop(0.7,'#3a3a3a'); g.addColorStop(1,'#c0c0c0');
      x.fillStyle=g; x.beginPath(); x.arc(cx,cy,r,0,Math.PI*2); x.fill();
    }
    var t=new TH.CanvasTexture(c);
    t.wrapS=t.wrapT=TH.RepeatWrapping; t.anisotropy=4; t.needsUpdate=true;
    return track(t);
  }
  // Evenly-spaced points around an obround (rounded-rect) perimeter, centred on 0.
  function obroundPts(hw, hh, r, spacing){
    r = Math.min(r, hw, hh);
    var pts = [];
    function line(x0,y0,x1,y1){
      var dx=x1-x0, dy=y1-y0, len=Math.sqrt(dx*dx+dy*dy);
      var steps=Math.max(1, Math.round(len/spacing));
      for(var i=0;i<steps;i++){ var u=i/steps; pts.push([x0+dx*u, y0+dy*u]); }
    }
    function arc(cx,cy,a0,a1){
      var len=Math.abs(a1-a0)*r, steps=Math.max(1, Math.round(len/spacing));
      for(var i=0;i<steps;i++){ var a=a0+(a1-a0)*(i/steps); pts.push([cx+Math.cos(a)*r, cy+Math.sin(a)*r]); }
    }
    line(-hw+r,-hh,  hw-r,-hh);
    arc ( hw-r,-hh+r, -Math.PI/2, 0);
    line( hw,-hh+r,   hw, hh-r);
    arc ( hw-r, hh-r, 0, Math.PI/2);
    line( hw-r, hh,  -hw+r, hh);
    arc (-hw+r, hh-r, Math.PI/2, Math.PI);
    line(-hw, hh-r,  -hw,-hh+r);
    arc (-hw+r,-hh+r, Math.PI, Math.PI*1.5);
    return pts;
  }
  // EXACTLY n points around an obround perimeter (even arc-length) — for frustum rings.
  function obroundRingN(hw, hh, r, n){
    r = Math.min(r, hw, hh);
    var sH=2*(hw-r), sV=2*(hh-r), aL=Math.PI*r/2, per=2*sH+2*sV+4*aL, out=[];
    for(var i=0;i<n;i++){
      var d=per*(i/n), x,y;
      if(d < sH){ x=-hw+r+d; y=-hh; }
      else if(d < sH+aL){ var a=-Math.PI/2+(d-sH)/aL*(Math.PI/2); x=hw-r+Math.cos(a)*r; y=-hh+r+Math.sin(a)*r; }
      else if(d < sH+aL+sV){ x=hw; y=-hh+r+(d-sH-aL); }
      else if(d < sH+2*aL+sV){ var a2=0+(d-sH-aL-sV)/aL*(Math.PI/2); x=hw-r+Math.cos(a2)*r; y=hh-r+Math.sin(a2)*r; }
      else if(d < 2*sH+2*aL+sV){ x=hw-r-(d-sH-2*aL-sV); y=hh; }
      else if(d < 2*sH+3*aL+sV){ var a3=Math.PI/2+(d-2*sH-2*aL-sV)/aL*(Math.PI/2); x=-hw+r+Math.cos(a3)*r; y=hh-r+Math.sin(a3)*r; }
      else if(d < 2*sH+3*aL+2*sV){ x=-hw; y=hh-r-(d-2*sH-3*aL-sV); }
      else { var a4=Math.PI+(d-2*sH-3*aL-2*sV)/aL*(Math.PI/2); x=-hw+r+Math.cos(a4)*r; y=-hh+r+Math.sin(a4)*r; }
      out.push([x,y]);
    }
    return out;
  }
  // Tapered obround WALL (conical frustum) between a front ring and a back ring —
  // the dark stepped pocket wall that gives the head its hollow depth.
  function obroundFrustum(hw0,hh0,r0,z0, hw1,hh1,r1,z1, n){
    var a=obroundRingN(hw0,hh0,r0,n), b=obroundRingN(hw1,hh1,r1,n);
    var pos=[], idx=[];
    for(var i=0;i<n;i++){ pos.push(a[i][0],a[i][1],z0); }
    for(var j=0;j<n;j++){ pos.push(b[j][0],b[j][1],z1); }
    for(var k=0;k<n;k++){
      var k2=(k+1)%n, A=k, B=k2, C=n+k, D=n+k2;
      idx.push(A,C,B,  B,C,D);
    }
    var g=new TH.BufferGeometry();
    g.setAttribute('position', new TH.Float32BufferAttribute(pos,3));
    g.setIndex(idx); g.computeVertexNormals();
    return track(g);
  }
  // Concentric rows of fine perforation dots filling an obround band (the front
  // spray collar). Drawn in the collar's own bbox so UVs map 1:1.
  function perfRingTex(px, OHW,OHH,OR, IHW,IHH,IR, rows, dotR){
    var c=document.createElement('canvas'); c.width=px; c.height=px;
    var x=c.getContext('2d');
    x.fillStyle='#d3d3cf'; x.fillRect(0,0,px,px);
    var sx=px/(2*OHW), sy=px/(2*OHH), cx=px/2, cy=px/2;
    var spacing = (2*OHW)/34;                     // even world spacing between dots
    for(var ri=0; ri<rows; ri++){
      var f=(ri+0.5)/rows;
      var hw=OHW+(IHW-OHW)*f, hh=OHH+(IHH-OHH)*f, rr=OR+(IR-OR)*f;
      var pts=obroundPts(hw,hh,rr, spacing);
      for(var k=0;k<pts.length;k++){
        var dx=cx+pts[k][0]*sx, dy=cy+pts[k][1]*sy;
        var g=x.createRadialGradient(dx,dy,0,dx,dy,dotR);
        g.addColorStop(0,'#45454a'); g.addColorStop(0.65,'#80807f'); g.addColorStop(1,'#d3d3cf');
        x.fillStyle=g; x.beginPath(); x.arc(dx,dy,dotR,0,Math.PI*2); x.fill();
      }
    }
    var t=new TH.CanvasTexture(c); t.anisotropy=8; t.needsUpdate=true;
    return track(t);
  }
  function brushRough(px){                                    // chrome rim micro-grain
    var c=document.createElement('canvas'); c.width=px; c.height=px;
    var x=c.getContext('2d');
    x.fillStyle='#3a3a3a'; x.fillRect(0,0,px,px);
    for(var i=0;i<2200;i++){
      var a=Math.random()*Math.PI*2, rr=Math.random()*px*0.7, g=40+Math.random()*60;
      x.strokeStyle='rgba('+g+','+g+','+g+',0.05)';
      x.beginPath();
      x.moveTo(px/2+Math.cos(a)*rr, px/2+Math.sin(a)*rr);
      x.lineTo(px/2+Math.cos(a)*(rr+18), px/2+Math.sin(a)*(rr+18));
      x.stroke();
    }
    var t=new TH.CanvasTexture(c);
    t.wrapS=t.wrapT=TH.RepeatWrapping; t.needsUpdate=true;
    return track(t);
  }

  /* =====================================================================
     STUDIO ENVIRONMENT  (procedural PMREM softbox — kept from baseline)
  ===================================================================== */
  function envEquirect(){
    var c=document.createElement('canvas'); c.width=1024; c.height=512;
    var x=c.getContext('2d');
    var g=x.createLinearGradient(0,0,0,512);
    g.addColorStop(0.00,'#3c3f44');
    g.addColorStop(0.40,'#cdcbc6');
    g.addColorStop(0.54,'#edece7');
    g.addColorStop(0.70,'#a6a6a8');
    g.addColorStop(1.00,'#161719');
    x.fillStyle=g; x.fillRect(0,0,1024,512);
    var b=x.createLinearGradient(0,70,0,240);
    b.addColorStop(0,'rgba(255,255,255,0)');
    b.addColorStop(0.5,'rgba(255,255,255,0.95)');
    b.addColorStop(1,'rgba(255,255,255,0)');
    x.fillStyle=b; x.fillRect(120,70,460,170);
    var b2=x.createLinearGradient(0,150,0,250);
    b2.addColorStop(0,'rgba(255,255,255,0)');
    b2.addColorStop(0.5,'rgba(255,255,255,0.5)');
    b2.addColorStop(1,'rgba(255,255,255,0)');
    x.fillStyle=b2; x.fillRect(650,150,290,90);
    x.fillStyle='rgba(255,255,255,0.32)'; x.fillRect(0,250,1024,7);
    var fb=x.createLinearGradient(0,360,0,512);
    fb.addColorStop(0,'rgba(130,130,134,0)');
    fb.addColorStop(1,'rgba(150,150,154,0.45)');
    x.fillStyle=fb; x.fillRect(0,360,1024,152);
    var t=new TH.CanvasTexture(c);
    t.mapping=TH.EquirectangularReflectionMapping; t.needsUpdate=true;
    var pmrem=new TH.PMREMGenerator(renderer);
    var rt=pmrem.fromEquirectangular(t);
    t.dispose(); pmrem.dispose();
    return rt;
  }

  /* =====================================================================
     SCENE / CAMERA / BACKGROUND
  ===================================================================== */
  var scene = new TH.Scene();
  var bgDark  = new TH.Color(0x141619);
  var bgLight = new TH.Color(0xeceef0);
  scene.background = (opts.background === 'light') ? bgLight
                   : (opts.background === 'transparent') ? null : bgDark;

  var camera = new TH.PerspectiveCamera(28, 1, 0.1, 100);
  camera.position.set(0, 0, 9);
  camera.lookAt(0, 0, 0);

  var envRT  = envEquirect();
  var envMap = envRT.texture;
  scene.environment = envMap;

  /* =====================================================================
     LIGHTS
  ===================================================================== */
  var key = new TH.DirectionalLight(0xffffff, 1.32);
  key.position.set(-3.3, 5.1, 4.3);
  key.castShadow = true;
  key.shadow.mapSize.set(1024,1024);
  key.shadow.camera.near = 0.5;
  key.shadow.camera.far  = 20;
  key.shadow.camera.left=-3; key.shadow.camera.right=3;
  key.shadow.camera.top=4;   key.shadow.camera.bottom=-4;
  key.shadow.bias = -0.0007;
  key.shadow.radius = 5;
  scene.add(key);

  var fill = new TH.DirectionalLight(0xffffff, 0.40);
  fill.position.set(4.1, 1.5, 2.6);
  scene.add(fill);

  var rimLight = new TH.DirectionalLight(0xffffff, 0.85);
  rimLight.position.set(2.6, 3.1, -4.2);
  scene.add(rimLight);

  var hemi = new TH.HemisphereLight(0xdfe3e8, 0x1e2023, 0.30);
  scene.add(hemi);

  /* =====================================================================
     GROUP HIERARCHY (REQUIRED):  scene -> tiltGroup -> spin -> model
  ===================================================================== */
  var tiltGroup = new TH.Group();
  var spin      = new TH.Group();
  tiltGroup.add(spin);
  scene.add(tiltGroup);

  var model = new TH.Group();
  spin.add(model);

  /* =====================================================================
     SHAPE HELPERS  (racetrack / rounded-rect oval paths)
  ===================================================================== */
  function roundedRectPath(path, hw, hh, r){
    r = Math.min(r, hw, hh);
    path.moveTo(-hw+r, -hh);
    path.lineTo(hw-r, -hh);
    path.absarc(hw-r, -hh+r, r, -Math.PI/2, 0, false);
    path.lineTo(hw, hh-r);
    path.absarc(hw-r, hh-r, r, 0, Math.PI/2, false);
    path.lineTo(-hw+r, hh);
    path.absarc(-hw+r, hh-r, r, Math.PI/2, Math.PI, false);
    path.lineTo(-hw, -hh+r);
    path.absarc(-hw+r, -hh+r, r, Math.PI, Math.PI*1.5, false);
    return path;
  }
  function ovalShape(hw, hh, r){
    var s = new TH.Shape();
    roundedRectPath(s, hw, hh, r);
    return s;
  }
  function ovalRingShape(ohw, ohh, or_, ihw, ihh, ir){
    var s = ovalShape(ohw, ohh, or_);
    var hole = new TH.Path();
    roundedRectPath(hole, ihw, ihh, ir);
    s.holes.push(hole);
    return s;
  }
  function extrudeRing(shape, depth, bt, bs, bseg, curve){
    var g = new TH.ExtrudeGeometry(shape, {
      depth: depth, bevelEnabled:true,
      bevelThickness:bt, bevelSize:bs, bevelSegments:bseg, curveSegments:curve||48, steps:1
    });
    g.center();
    return track(g);
  }
  // Flat extrude — NO bevel (beveled extrudes of rounded shapes leave seam "flaps"
  // at the path start vertex; the inner face pieces are viewed flat-on so a crisp
  // edge reads cleaner than a flap).
  function extrudeFlat(shape, depth, curve){
    var g = new TH.ExtrudeGeometry(shape, {
      depth: depth, bevelEnabled:false, curveSegments:curve||64, steps:1
    });
    g.center();
    return track(g);
  }

  /* =====================================================================
     MATERIALS  (mutable refs — re-tinted by setFinish)
       body   = anodized / soft-touch outer shell
       chrome = polished mirror outer rim + collars + lips
       tunnel = glossy dark concave inner wall (reads the hollow depth)
       flange = silver/grey perforated ring on the front face
       ring   = contrasting coloured inner SPRAY ring insert (red/cream/silver)
       knurl  = grippy metallic connector band
       thread = chrome 1/2" male threaded connector
  ===================================================================== */
  var knurlBump  = dotBump(256, 26, 8, 4.4, '#34373c', '#c4c6c6'); knurlBump.repeat.set(1, 1);
  var threadBump = stripeBump(64, 10); threadBump.repeat.set(1, 6);
  var outerPerf  = perfBump(256, 90, 6, 2.2); outerPerf.repeat.set(1,1);
  var innerPerf  = perfBump(256, 150, 11, 1.3); innerPerf.repeat.set(1,1);
  var chromeRough= brushRough(256);

  var bodyMat = track(new TH.MeshStandardMaterial({
    color:0x52555b, metalness:0.78, roughness:0.40, side:TH.DoubleSide,
    envMap:envMap, envMapIntensity:1.05 }));
  var chromeMat = track(new TH.MeshStandardMaterial({
    color:0xf0f1f3, metalness:1.0, roughness:0.10,
    roughnessMap:chromeRough, envMap:envMap, envMapIntensity:1.4 }));
  // tunnelMat = dark matte CONICAL WALL of the hollow (double-sided: we see its bore).
  var tunnelMat = track(new TH.MeshStandardMaterial({
    color:0x35383d, metalness:0.45, roughness:0.6, side:TH.DoubleSide,
    envMap:envMap, envMapIntensity:0.5 }));
  // flangeMat = light PERFORATED SPRAY RING — map/bump set later from perfRingTex.
  var flangeMat = track(new TH.MeshStandardMaterial({
    color:0xffffff, metalness:0.18, roughness:0.6,
    envMap:envMap, envMapIntensity:0.5 }));
  // ringMat = TRANSLUCENT rose lens at the funnel base — you can see through it.
  var ringMat = track(new TH.MeshStandardMaterial({
    color:0x8fa9c0, metalness:0.0, roughness:0.32, transparent:true, opacity:0.48,
    depthWrite:false, envMap:envMap, envMapIntensity:0.7 }));
  var knurlMat = track(new TH.MeshStandardMaterial({
    color:0x44474c, metalness:1.0, roughness:0.34,
    bumpMap:knurlBump, bumpScale:0.016, envMap:envMap, envMapIntensity:1.15 }));
  var threadMat = track(new TH.MeshStandardMaterial({
    color:0x8e9196, metalness:0.9, roughness:0.40,
    bumpMap:threadBump, bumpScale:0.010, envMap:envMap, envMapIntensity:0.95 }));

  /* =====================================================================
     HEAD — chunky near-STADIUM ring with a TRUE see-through hollow (Dyson-style).
     Front face, outer -> centre:
       [thin gunmetal rim] -> [wide FLAT light perforated spray ring (fine dots)]
       -> [dark conical wall funnelling back] -> [translucent rose lens]
       -> open bore (you can see through it).
  ===================================================================== */
  var head = new TH.Group();
  var zF = BODY_DEPTH/2;

  // 1) BODY — gunmetal obround ring, hole bored straight THROUGH (see-through).
  //    extrudeFlat = crisp hole with ZERO bevel "flap" seams.
  var bodyGeo = extrudeFlat(
    ovalRingShape(HEAD_HW, HEAD_HH, HEAD_R, HOLE_HW, HOLE_HH, HOLE_R),
    BODY_DEPTH, 120);
  var bodyMesh = new TH.Mesh(bodyGeo, bodyMat);
  bodyMesh.castShadow = true; bodyMesh.receiveShadow = true;
  head.add(bodyMesh);
  // OUTER EDGE ROLL — a soft front + back chamfer swept around the perimeter (custom
  // frustum, NO bevel) rounds the outer edge without any ExtrudeGeometry seam flaps.
  var chamF = obroundFrustum(HEAD_HW-0.024, HEAD_HH-0.024, Math.max(0.05,HEAD_R-0.024), zF,
                             HEAD_HW, HEAD_HH, HEAD_R, zF-0.030, 200);
  var chamFMesh = new TH.Mesh(chamF, bodyMat); chamFMesh.castShadow=true; head.add(chamFMesh);
  var chamB = obroundFrustum(HEAD_HW, HEAD_HH, HEAD_R, -zF+0.030,
                             HEAD_HW-0.024, HEAD_HH-0.024, Math.max(0.05,HEAD_R-0.024), -zF, 200);
  var chamBMesh = new TH.Mesh(chamB, bodyMat); chamBMesh.castShadow=true; head.add(chamBMesh);

  // 2) PERFORATED SPRAY RING — wide FLAT light ring of concentric fine DOTS on the
  //    front face. The perforation lives on this OUTER ring (not inside the hollow).
  var COL_OHW = HEAD_HW - 0.072, COL_OHH = HEAD_HH - 0.072;       // leaves a wide dark rim
  var PERF_IHW = HOLE_HW + 0.046, PERF_IHH = HOLE_HH + 0.046;     // inner edge of the ring
  var perfTex = perfRingTex(640, COL_OHW, COL_OHH, Math.max(0.06,HEAD_R-0.072),
                            PERF_IHW, PERF_IHH, Math.max(0.05,HOLE_R+0.03), 3, 2.7);
  flangeMat.color.setHex(0xffffff); flangeMat.map = perfTex;
  flangeMat.bumpMap = perfTex; flangeMat.bumpScale = 0.009; flangeMat.envMapIntensity = 0.38;
  var collarGeoH = extrudeFlat(
    ovalRingShape(COL_OHW, COL_OHH, Math.max(0.06,HEAD_R-0.072),
                  PERF_IHW, PERF_IHH, Math.max(0.05,HOLE_R+0.03)),
    0.02, 120);
  // remap UVs so the perforation texture maps 1:1 over the ring's bounding box
  (function(g){ var p=g.attributes.position, uv=g.attributes.uv;
    for(var i=0;i<p.count;i++){ uv.setXY(i,(p.getX(i)+COL_OHW)/(2*COL_OHW),(p.getY(i)+COL_OHH)/(2*COL_OHH)); }
    uv.needsUpdate=true; })(collarGeoH);
  var collarH = new TH.Mesh(collarGeoH, flangeMat);
  collarH.position.z = zF - 0.002;
  collarH.receiveShadow = true;
  head.add(collarH);

  // 3) CONICAL WALL — dark funnel from the ring's inner edge back to the bore; gives
  //    the hollow its depth and the stepped look (tunnelMat is double-sided).
  var funnelGeo = obroundFrustum(
    PERF_IHW-0.004, PERF_IHH-0.004, Math.max(0.06,HOLE_R+0.036), zF-0.006,
    HOLE_HW+0.002, HOLE_HH+0.002, HOLE_R+0.002, zF-POCKET_DEPTH, 170);
  var funnel = new TH.Mesh(funnelGeo, tunnelMat);
  funnel.receiveShadow = true;
  head.add(funnel);

  // 4) LENS — translucent rose disc at the funnel base; you can see THROUGH it into
  //    the open bore behind.
  var lensGeo = extrudeFlat(
    ovalShape(HOLE_HW-0.004, HOLE_HH-0.004, Math.max(0.04,HOLE_R-0.004)),
    0.012, 100);
  var lens = new TH.Mesh(lensGeo, ringMat);
  lens.position.z = zF - POCKET_DEPTH;
  head.add(lens);

  head.position.y = HEAD_CY;
  model.add(head);

  /* =====================================================================
     WATERSTRAAL — consistente bundel uit de sproeiring (optioneel).
     Ballistische dashed lines, meedraaiend met het model; de dash-flow
     wordt door de element-loop gestept (reduced-motion: statisch).
  ===================================================================== */
  var water = null;
  if (opts.water !== false) {
    var wGroup = new TH.Group(); wGroup.position.y = HEAD_CY;
    var wMat = new TH.LineDashedMaterial({ color:0x8fa9c0, transparent:true, opacity:0.72, dashSize:0.26, gapSize:0.035 });
    var wLines = [], WGA = 2.399963, WNL = 18;
    for (var wi = 0; wi < WNL; wi++) {
      var wa = (wi*WGA)%(Math.PI*2), wk = 0.35 + ((wi*0.37)%1)*0.4;
      var wx = Math.cos(wa)*(0.226+(0.288-0.226)*wk);
      var wy = Math.sin(wa)*(0.346+(0.398-0.346)*wk);
      var wpts = [], WS = 12, WT = 1.9;
      for (var ws = 0; ws <= WS; ws++) { var wt = ws/WS*WT;
        wpts.push(wx*(1-0.22*wt/WT), wy - 0.13*wt*wt, zF + 0.74*wt); }
      var wg = new TH.BufferGeometry(); wg.setAttribute('position', new TH.Float32BufferAttribute(wpts,3));
      var wl = new TH.Line(wg, wMat); wl.computeLineDistances();
      wl.userData.orig = wl.geometry.attributes.lineDistance.array.slice();
      wl.userData.off = (wi*0.041)%0.09;
      wLines.push(wl); wGroup.add(wl);
    }
    model.add(wGroup);
    var wFlow = 0;
    water = { step: function(){ wFlow += 0.052;
      for (var i2=0;i2<wLines.length;i2++){ var att=wLines[i2].geometry.attributes.lineDistance, org=wLines[i2].userData.orig, off2=wLines[i2].userData.off;
        for (var j2=0;j2<org.length;j2++) att.array[j2]=org[j2]+off2-wFlow;
        att.needsUpdate=true; } } };
  }

  /* =====================================================================
     STEM / HANDLE — long slim lathe barrel, knurled band, chrome thread.
     Profile (x=radius, y=height) bottom -> top. Head sits at y=HEAD_CY;
     barrel shoulder meets the head underside, thread tip near BASE_Y.
  ===================================================================== */
  // Straight UNTAPERED cylinder (HANDLE_R), the longest segment; a clean step
  // down to the threaded spigot at the bottom. Knurl is a flush texture overlay.
  // The top flares with a smooth CONCAVE fillet that fairs into the head underside —
  // no hard shoulder/undercut. Head bottom is at y ~= HEAD_CY-HEAD_HH (0.315); the
  // flare crosses it gently and merges inside the head.
  var stemProfile = [
    [0.000, -1.275],  // thread base centre
    [0.085, -1.275],  // thread OD
    [0.090, -1.235],
    [0.090, -1.085],  // top of thread region
    [0.135, -1.075],  // step up to the boss
    [HANDLE_R, -1.050], // boss = handle Ø
    [HANDLE_R,  0.250], // straight cylinder up to just below the head
    [0.168,  0.292],   // gentle concave flare begins
    [0.176,  0.330],   // crosses the head underside
    [0.190,  0.368],   // fairs into the head
    [0.150,  0.390],   // necks shut INSIDE the head (hidden)
    [0.000,  0.396]
  ];
  var stemVecs = stemProfile.map(function(p){ return new TH.Vector2(p[0],p[1]); });
  var stemGeo = track(new TH.LatheGeometry(stemVecs, 64));
  var stemMesh = new TH.Mesh(stemGeo, bodyMat);
  stemMesh.castShadow = true; stemMesh.receiveShadow = true;
  model.add(stemMesh);

  // KNURLED collar — concave diamond-dimple grip texture, FLUSH with the handle.
  var knurlGeo = track(new TH.CylinderGeometry(HANDLE_R + 0.002, HANDLE_R, 0.26, 64, 1, true));
  var knurlMesh = new TH.Mesh(knurlGeo, knurlMat);
  knurlMesh.position.y = -0.815;   // centre of the -0.685 .. -0.945 band
  knurlMesh.castShadow = true; knurlMesh.receiveShadow = true;
  model.add(knurlMesh);

  // dark step ring between the boss and the thread
  var collarGeo = track(new TH.CylinderGeometry(0.135, 0.094, 0.05, 48));
  var collarMesh = new TH.Mesh(collarGeo, bodyMat);
  collarMesh.position.y = -1.078; collarMesh.castShadow = true; model.add(collarMesh);

  // threaded 1/2" male connector at the very bottom (narrower than the handle)
  var threadGeo = track(new TH.CylinderGeometry(0.090, 0.086, 0.165, 48, 1, false));
  var threadMesh = new TH.Mesh(threadGeo, threadMat);
  threadMesh.position.y = -1.185; threadMesh.castShadow = true; threadMesh.receiveShadow = true;
  model.add(threadMesh);
  var threadTipGeo = track(new TH.CylinderGeometry(0.084, 0.078, 0.03, 48));
  var threadTip = new TH.Mesh(threadTipGeo, threadMat); threadTip.position.y = -1.272; model.add(threadTip);

  /* =====================================================================
     GROUND CONTACT SHADOW  (stays flat on the scene — NOT on spin/model)
  ===================================================================== */
  function shadowTex(){
    var c=document.createElement('canvas'); c.width=256; c.height=256;
    var x=c.getContext('2d');
    var g=x.createRadialGradient(128,128,6,128,128,124);
    g.addColorStop(0,'rgba(0,0,0,0.5)');
    g.addColorStop(0.5,'rgba(0,0,0,0.24)');
    g.addColorStop(1,'rgba(0,0,0,0)');
    x.fillStyle=g; x.fillRect(0,0,256,256);
    var t=new TH.CanvasTexture(c); t.needsUpdate=true; return track(t);
  }
  var contactMat = track(new TH.MeshBasicMaterial({
    map:shadowTex(), transparent:true, depthWrite:false, opacity:0.85 }));
  var contactGeo = track(new TH.PlaneGeometry(1.4, 0.95));
  var contact = new TH.Mesh(contactGeo, contactMat);
  contact.rotation.x = -Math.PI/2;
  contact.position.y = BASE_Y - 0.001;
  contact.renderOrder = -1;
  scene.add(contact);                 // flat under the product, does not spin

  var floorMat = track(new TH.ShadowMaterial({ opacity:0.20 }));
  var floorGeo = track(new TH.PlaneGeometry(24, 24));
  var floor = new TH.Mesh(floorGeo, floorMat);
  floor.rotation.x = -Math.PI/2; floor.position.y = BASE_Y; floor.receiveShadow = true;
  scene.add(floor);

  /* =====================================================================
     FINISHES  — swap body / ring / rim / flange / knurl / tunnel.
     Grounded in the photos: red ring on gunmetal; cream ring on black &
     beige; silver ring on white; warm cream on gold & pink. Chrome rim,
     collars & thread stay polished metal on every finish.
  ===================================================================== */
  var finishes = ['gunmetal','black','white'];
  // Body = anodized aluminium: a soft metallic sheen, NOT a mirror. Keep metalness
  // moderate, roughness high and envMapIntensity low so the dark base colour reads
  // dark under the bright studio softbox. Chrome rim/knurl/thread stay polished.
  var FINISH = {
    gunmetal: { body:0x4c4f55, bodyMetal:0.55, bodyRough:0.62, bodyEnv:0.55,
                ring:0x5c7a95, ringMetal:0.14, ringRough:0.52,
                flange:0xc6c8cc, rim:0xeceef0, rimRough:0.12,
                knurl:0x3c3f44, knurlMetal:0.95, tunnel:0x5b5e64 },
    black:    { body:0x202327, bodyMetal:0.45, bodyRough:0.64, bodyEnv:0.48,
                ring:0x5c7a95, ringMetal:0.14, ringRough:0.52,
                flange:0xc8cacd, rim:0xeef0f2, rimRough:0.10,
                knurl:0x1b1e22, knurlMetal:0.9, tunnel:0x4a4d53 },
    white:    { body:0xeae7e1, bodyMetal:0.10, bodyRough:0.58, bodyEnv:0.58,
                ring:0x5c7a95, ringMetal:0.14, ringRough:0.52,
                flange:0xcfd1d4, rim:0xf0f1f3, rimRough:0.10,
                knurl:0xc0c2c6, knurlMetal:0.9, tunnel:0x6d7075 }
  };

  var currentFinish = FINISH[opts.finish] ? opts.finish : 'gunmetal';
  function applyFinish(name){
    var f = FINISH[name]; if(!f) return;
    currentFinish = name;
    // Only the BODY + KNURL take the finish colour. The perforated collar stays
    // light-grey, the glass plate glassy and the pocket wall dark on every finish
    // (the spray face is not part of the colour variant).
    bodyMat.color.setHex(f.body);
    bodyMat.metalness = f.bodyMetal; bodyMat.roughness = f.bodyRough; bodyMat.envMapIntensity = f.bodyEnv;
    knurlMat.color.setHex(f.knurl); knurlMat.metalness = f.knurlMetal;
    bodyMat.needsUpdate = knurlMat.needsUpdate = true;
  }
  applyFinish(currentFinish);
  function setFinish(name){ applyFinish(name); }

  /* =====================================================================
     BACKGROUND SWAP
  ===================================================================== */
  function setBackground(name){
    scene.background = (name === 'light') ? bgLight
                     : (name === 'transparent') ? null : bgDark;
  }

  /* =====================================================================
     FIT — frame the product for ANY contained canvas (~12% margin).
     Never reads window.*. Uses a pre-measured bounding box of the solid
     product parts + perspective FOV, accounting for portrait & landscape.
  ===================================================================== */
  var fitBox = new TH.Box3();
  (function(){
    // Update ALL world matrices first (head Y-offset, model/spin/tilt), otherwise the
    // head's +Y offset is missed and the framing clips the top of the product.
    scene.updateMatrixWorld(true);
    fitBox.setFromObject(model);
  })();
  var fitCenter = new TH.Vector3(); fitBox.getCenter(fitCenter);
  var fitSize   = new TH.Vector3(); fitBox.getSize(fitSize);
  var objW = fitSize.x, objH = fitSize.y;

  function fit(width, height){
    width  = Math.max(1, width  || 1);
    height = Math.max(1, height || 1);
    var aspect = width / height;
    camera.aspect = aspect;

    var margin = 1.12; // ~12% breathing room
    var vFov = camera.fov * Math.PI/180;
    var distH = (objH * margin * 0.5) / Math.tan(vFov/2);
    var hFov  = 2 * Math.atan(Math.tan(vFov/2) * aspect);
    var distW = (objW * margin * 0.5) / Math.tan(hFov/2);

    var dist = Math.max(distH, distW);
    dist = Math.max(dist, 2.2);

    camera.position.set(0, fitCenter.y, dist);
    camera.lookAt(0, fitCenter.y, 0);
    camera.near = Math.max(0.05, dist - objH*1.5);
    camera.far  = dist + objH*2 + 10;
    camera.updateProjectionMatrix();
  }
  fit(1, 1);

  /* =====================================================================
     DISPOSE
  ===================================================================== */
  function dispose(){
    for(var i=0;i<disposables.length;i++){
      var o = disposables[i];
      if(o && typeof o.dispose === 'function'){ try{ o.dispose(); }catch(e){} }
    }
    disposables.length = 0;
    if(envRT && envRT.dispose){ try{ envRT.dispose(); }catch(e){} }
    scene.environment = null;
    scene.traverse(function(obj){
      if(obj.geometry && typeof obj.geometry.dispose === 'function'){ try{ obj.geometry.dispose(); }catch(e){} }
      if(obj.material){
        var mats = Array.isArray(obj.material) ? obj.material : [obj.material];
        for(var k=0;k<mats.length;k++){ if(mats[k] && mats[k].dispose){ try{ mats[k].dispose(); }catch(e){} } }
      }
    });
  }

  /* ---------- LINE-ART: alleen het product (tiltGroup) → lijntekening op donker; staging verbergen ---------- */
  (function(){
    if (typeof floor !== 'undefined' && floor) floor.visible = false;
    if (typeof contact !== 'undefined' && contact) contact.visible = false;
    var lineMat = new TH.LineBasicMaterial({ color: 0xc4ccd3, transparent: true, opacity: 0.62 });
    var soft    = new TH.LineBasicMaterial({ color: 0x8b949d, transparent: true, opacity: 0.34 });
    var meshes = [];
    tiltGroup.traverse(function(o){ if (o.isMesh && o.geometry) meshes.push(o); });
    meshes.forEach(function(o){
      try {
        var eg = new TH.EdgesGeometry(o.geometry, 18);
        o.add(new TH.LineSegments(eg, lineMat));
      } catch (e) {}
      // flat, near-background fill: reads as a subtle silhouette + occludes back edges (clean line-art)
      o.material = new TH.MeshBasicMaterial({ color: 0x14171c, transparent: true, opacity: 0.34, depthWrite: false });
    });
  })();

  /* ---------- interne onderdelen, zichtbaar via de cutaway: koolstoffilter in de steel + VC-capsule ---------- */
  (function(){
    function part(geo, fillHex, edgeHex){
      var mesh = new TH.Mesh(geo, new TH.MeshBasicMaterial({ color: fillHex, transparent: true, opacity: 0.36, depthWrite: false }));
      mesh.add(new TH.LineSegments(new TH.EdgesGeometry(geo, 14), new TH.LineBasicMaterial({ color: edgeHex, transparent: true, opacity: 0.82 })));
      return mesh;
    }
    var R = HANDLE_R;
    // koolstoffilter (onder-midden van de steel)
    var flt = new TH.Group();
    flt.add(part(new TH.CylinderGeometry(R*0.72, R*0.72, 0.60, 40), 0x161a20, 0xc4ccd3));
    var fa = part(new TH.CylinderGeometry(R*0.78, R*0.72, 0.05, 40), 0x161a20, 0xc4ccd3); fa.position.y = 0.30; flt.add(fa);
    var fb = part(new TH.CylinderGeometry(R*0.72, R*0.78, 0.05, 40), 0x161a20, 0xc4ccd3); fb.position.y = -0.30; flt.add(fb);
    flt.position.y = -0.42; model.add(flt);
    // vitamine C-capsule (net onder de kop) — amber zodat 'ie opvalt door de cutaway
    var vc = new TH.Group();
    vc.add(part(new TH.CylinderGeometry(R*0.66, R*0.66, 0.26, 36), 0x2c2212, 0xf2c14e));
    var va = part(new TH.CylinderGeometry(R*0.76, R*0.74, 0.035, 40), 0x161a20, 0xe9d6ac); va.position.y = 0.15; vc.add(va);
    var vb = part(new TH.CylinderGeometry(R*0.74, R*0.76, 0.035, 40), 0x161a20, 0xe9d6ac); vb.position.y = -0.15; vc.add(vb);
    vc.position.y = 0.06; model.add(vc);
  })();

  return {
    scene: scene,
    camera: camera,
    spin: spin,
    tiltGroup: tiltGroup,
    water: water,
    setFinish: function(){ /* line-art: vaste lijntekening-look, finish-kleur uitgeschakeld */ },
    setBackground: setBackground,
    fit: fit,
    finishes: finishes,
    dispose: dispose
  };
}

// ═══════════════════════════════════════════════════════════════
// <rince-turntable> — web-component shell around buildRinceTurntable().
//  • Lazy-loads three.js (r128) only when the section nears the viewport.
//  • Runs the render loop; pauses when off-screen (perf).
//  • Auto-rotate is gated on prefers-reduced-motion.
//  • Pointer-drag to rotate/tilt; control buttons for finish / background / auto.
//  • Interactive feature hotspots: a ring of clickable dots projected onto the
//    model; clicking one rotates the feature toward the camera, eases the camera
//    in, and opens a glass feature card. Driven entirely from the camera the
//    model returns (no model changes needed).
//  • The optimized model builder buildRinceTurntable(THREE, renderer, opts) is
//    defined above this in the assembled asset.
// ═══════════════════════════════════════════════════════════════
(function () {
  const THREE_SRC = window.__RINCE_THREE_SRC || 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
  let threePromise = null;
  /* PERFORMANCE: op mobiel pas laden na het load-event + idle. Deze sectie is de
     hero, dus zonder uitstel blokkeert het parsen van de ~589 KB Three.js-bundel
     precies het moment waarop FCP/LCP wordt gemeten. Desktop laadt direct door. */
  function loadThree() {
    if (window.THREE) return Promise.resolve(window.THREE);
    if (threePromise) return threePromise;
    threePromise = new Promise((resolve, reject) => {
      const go = () => {
        const s = document.createElement('script');
        s.src = THREE_SRC;
        s.crossOrigin = 'anonymous';
        s.onload = () => resolve(window.THREE);
        s.onerror = reject;
        document.head.appendChild(s);
      };
      if (window.__rinceDefer3D && window.__rinceWhenIdle) window.__rinceWhenIdle(go);
      else go();
    });
    return threePromise;
  }

  // Built-in anchor map: feature "area" -> a point on the model (spin-local
  // coords), the surface normal it faces, and how far to zoom in (× base dist).
  const ANCHORS = {
    sproeiring:  { pos: [0, 0.78, 0.16],  normal: [0, 0, 1], zoom: 0.56 },
    filter:      { pos: [0, -0.15, 0.15], normal: [0, 0, 1], zoom: 0.50 },
    connector:   { pos: [0, -0.815, 0.16], normal: [0, 0, 1], zoom: 0.46 },
    aansluiting: { pos: [0, -1.18, 0.08], normal: [0, 0, 1], zoom: 0.42 },
    materiaal:   { pos: [0.36, 0.775, 0.0], normal: [1, 0, 0], zoom: 0.56 },
  };

  class RinceTurntable extends HTMLElement {
    #scratch = null;

    connectedCallback() {
      if (this._wired) return;
      this._wired = true;
      this.canvas = this.querySelector('canvas');
      if (!this.canvas) return;
      this.reduceMQ = matchMedia('(prefers-reduced-motion: reduce)');
      this.auto = this.dataset.auto !== 'false' && !this.reduceMQ.matches;
      this.finish = this.dataset.finish || 'gunmetal';
      this.bg = this.dataset.background || 'dark';
      this.tilt = -0.04;
      this.onscreen = true;
      this.activeFeat = -1;
      this.targetSpin = null;
      this.featOn = this.dataset.features !== 'off';
      this.features = this.#readFeatures();
      this.wireControls();
      this.syncControlState();
      this.#armInit();
    }

    // Robust lazy-init: IntersectionObserver is only a hint. We also viewport-check
    // on rAF / scroll / resize and a few timed passes, because IO callbacks are
    // unreliable in some embedded/webview/preview contexts (and never firing there
    // would leave the loader covering the canvas forever).
    #armInit() {
      const start = () => { if (!this.inited) { this.#disarmInit(); this.init(); } };
      const inView = () => {
        if (this.inited) return false;
        // Not laid out (e.g. on a hidden SPA/router page) — wait until it's shown.
        if (this.offsetParent === null && this.getClientRects().length === 0) return false;
        const r = this.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight || 0;
        const vw = window.innerWidth || document.documentElement.clientWidth || 0;
        // treat a collapsed/zero viewport as "show it" so we never stall
        if (vh < 2 || vw < 2) return true;
        return r.bottom > -300 && r.top < vh + 300 && r.right > -50 && r.left < vw + 50;
      };
      this._check = () => { if (inView()) start(); };
      try {
        this._io = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) start(); }, { rootMargin: '300px' });
        this._io.observe(this);
      } catch (e) {}
      window.addEventListener('scroll', this._check, { passive: true });
      window.addEventListener('resize', this._check, { passive: true });
      requestAnimationFrame(this._check);
      this._timers = [100, 400, 900, 1600].map((t) => setTimeout(this._check, t));
    }

    #disarmInit() {
      try { this._io && this._io.disconnect(); } catch (e) {}
      if (this._check) {
        window.removeEventListener('scroll', this._check);
        window.removeEventListener('resize', this._check);
      }
      (this._timers || []).forEach(clearTimeout);
      this._timers = null;
    }

    #hideLoader() {
      const root = this.controls || this.parentElement || this;
      const loader = root && root.querySelector ? root.querySelector('.rince-tt__loader') : null;
      if (loader) { loader.style.opacity = '0'; loader.style.pointerEvents = 'none'; setTimeout(() => { loader.style.display = 'none'; }, 600); }
    }

    #readFeatures() {
      const sc = this.querySelector('script.rince-tt-features');
      if (!sc) return [];
      try {
        const list = JSON.parse(sc.textContent || '[]');
        return list
          .map((f) => ({ ...f, anchor: ANCHORS[f.area] }))
          .filter((f) => f.anchor);
      } catch (e) { return []; }
    }

    async init() {
      if (this.inited) return;
      this.inited = true;
      this.#disarmInit();
      let THREE;
      try { THREE = await loadThree(); } catch (e) { console.error('[rince-turntable] three.js load failed', e); this.fail(); return; }
      if (!this.isConnected) return;
      try {
        this.THREE = THREE;
        const renderer = new THREE.WebGLRenderer({ canvas: this.canvas, antialias: true, alpha: true });
        /* PERFORMANCE: op mobiel maximaal 1.5x i.p.v. 2x — scheelt ~44% van de te
           renderen pixels (en dus GPU-werk en batterij) zonder zichtbaar verschil. */
        renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, (window.innerWidth || 1024) < 750 ? 1.5 : 2));
        renderer.setClearColor(0x000000, 0);   // transparent clear -> CSS background shows through
        renderer.outputEncoding = THREE.sRGBEncoding;
        renderer.toneMapping = THREE.ACESFilmicToneMapping;
        renderer.toneMappingExposure = 1.0;
        renderer.shadowMap.enabled = true;
        renderer.shadowMap.type = THREE.PCFSoftShadowMap;
        this.renderer = renderer;
        this.built = buildRinceTurntable(THREE, renderer, { finish: this.finish, background: this.bg, water: this.dataset.water !== 'false' });
        this.#scratch = { a: new THREE.Vector3(), b: new THREE.Vector3(), v: new THREE.Vector3() };
        this.resize();
        this.curDist = this.baseDist; this.curTargetY = this.baseY;
        if (this.features.length) this.#buildHotspots();
        this.visObserver = new IntersectionObserver((es) => { this.onscreen = es[0].isIntersecting; }, { threshold: 0.01 });
        this.visObserver.observe(this);
        this.ro = new ResizeObserver(() => this.resize());
        this.ro.observe(this.canvas.parentElement || this);
        this.bindDrag();
      } catch (e) { console.error('[rince-turntable] init failed', e); this.fail(); return; }
      this.canvas.classList.add('is-ready');
      this.setAttribute('data-ready', '');
      this.#hideLoader();
      this.loop();
    }

    resize() {
      if (!this.renderer || !this.built) return;
      const box = (this.canvas.parentElement || this.canvas).getBoundingClientRect();
      const w = Math.max(1, Math.round(box.width));
      const h = Math.max(1, Math.round(box.height));
      this.renderer.setSize(w, h, false);
      this.built.fit(w, h);
      // Capture the default framing the model just set, before the loop drives the camera.
      const cam = this.built.camera;
      this.baseDist = cam.position.z;
      this.baseY = cam.position.y;
      if (this.activeFeat < 0) { this.targetDist = this.baseDist; this.targetY = this.baseY; }
      if (this.curDist == null) { this.curDist = this.baseDist; this.curTargetY = this.baseY; }
    }

    loop() {
      this.raf = requestAnimationFrame(() => this.loop());
      if (!this.onscreen || !this.built) return;
      const b = this.built;
      if (this.auto && !this.dragging && this.activeFeat < 0) b.spin.rotation.y += 0.0035;
      if (b.water && !this.reduceMQ.matches) b.water.step();
      if (this.activeFeat >= 0 && this.targetSpin != null && !this.dragging) {
        let d = this.targetSpin - b.spin.rotation.y;
        d = Math.atan2(Math.sin(d), Math.cos(d));
        b.spin.rotation.y += d * 0.12;
      }
      b.tiltGroup.rotation.x += (this.tilt - b.tiltGroup.rotation.x) * 0.1;
      this.curDist += (this.targetDist - this.curDist) * 0.09;
      this.curTargetY += (this.targetY - this.curTargetY) * 0.09;
      b.camera.position.set(0, this.curTargetY, this.curDist);
      b.camera.lookAt(0, this.curTargetY, 0);
      this.renderer.render(b.scene, b.camera);
      if (this.featOn && this.features.length) this.#updateHotspots();
    }

    bindDrag() {
      const c = this.canvas;
      let px = 0, py = 0;
      c.addEventListener('pointerdown', (e) => { this.dragging = true; px = e.clientX; py = e.clientY; c.setPointerCapture(e.pointerId); });
      c.addEventListener('pointermove', (e) => {
        if (!this.dragging || !this.built) return;
        this.built.spin.rotation.y += (e.clientX - px) * 0.008;
        this.targetSpin = null;
        this.tilt = Math.max(-0.5, Math.min(0.4, this.tilt + (e.clientY - py) * 0.005));
        px = e.clientX; py = e.clientY;
      });
      const end = () => { this.dragging = false; };
      c.addEventListener('pointerup', end);
      c.addEventListener('pointercancel', end);
    }

    /* ---------- feature hotspots + card ---------- */
    #buildHotspots() {
      const layer = document.createElement('div');
      layer.className = 'rince-tt__hotspots';
      this.features.forEach((f, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'rince-tt__hot';
        btn.setAttribute('aria-label', f.title || ('Feature ' + (i + 1)));
        btn.innerHTML = '<i>' + (i + 1) + '</i>';
        btn.addEventListener('click', () => this.#selectFeat(i));
        f.el = btn;
        layer.appendChild(btn);
      });
      this.hotLayer = layer;
      this.appendChild(layer);

      const card = document.createElement('div');
      card.className = 'rince-tt__featcard';
      card.innerHTML =
        '<button class="rince-tt__featcard-x" type="button" aria-label="Sluiten">&times;</button>' +
        '<div class="rince-tt__featcard-idx"></div>' +
        '<h3 class="rince-tt__featcard-title"></h3>' +
        '<p class="rince-tt__featcard-body"></p>' +
        '<div class="rince-tt__featcard-spec"></div>';
      card.querySelector('.rince-tt__featcard-x').addEventListener('click', () => this.#closeCard());
      this.card = card;
      this.appendChild(card);
      if (!this.featOn) layer.style.display = 'none';
    }

    #selectFeat(i) {
      const b = this.built, THREE = this.THREE;
      this.activeFeat = (this.activeFeat === i) ? -1 : i;
      this.features.forEach((f, j) => f.el.classList.toggle('is-active', j === this.activeFeat));
      if (this.activeFeat < 0) { this.#closeCard(); return; }
      const f = this.features[i];
      this.card.querySelector('.rince-tt__featcard-idx').textContent = f.idx || '';
      this.card.querySelector('.rince-tt__featcard-title').textContent = f.title || '';
      this.card.querySelector('.rince-tt__featcard-body').textContent = f.body || '';
      const spec = this.card.querySelector('.rince-tt__featcard-spec');
      spec.textContent = f.spec || '';
      spec.style.display = f.spec ? '' : 'none';
      // rotate the feature toward the camera, ease the camera in
      const n = f.anchor.normal;
      this.targetSpin = -Math.atan2(n[0], n[2]);
      const wp = this.#scratch.a.set(f.anchor.pos[0], f.anchor.pos[1], f.anchor.pos[2]);
      b.spin.localToWorld(wp);
      this.targetY = wp.y;
      this.targetDist = this.baseDist * (f.anchor.zoom || 0.6);
      this.card.classList.add('is-show');
      const root = this.controls || this;
      root.classList.add('is-carding');
    }

    #closeCard() {
      if (this.card) this.card.classList.remove('is-show');
      const root = this.controls || this;
      root.classList.remove('is-carding');
      this.activeFeat = -1;
      this.targetSpin = null;
      this.targetY = this.baseY;
      this.targetDist = this.baseDist;
      this.features.forEach((f) => f.el && f.el.classList.remove('is-active'));
    }

    #updateHotspots() {
      const b = this.built, s = this.#scratch;
      const cw = this.canvas.clientWidth || 1, ch = this.canvas.clientHeight || 1;
      for (const f of this.features) {
        const wp = s.a.set(f.anchor.pos[0], f.anchor.pos[1], f.anchor.pos[2]);
        b.spin.localToWorld(wp);
        const wn = s.b.set(
          f.anchor.pos[0] + f.anchor.normal[0] * 0.3,
          f.anchor.pos[1] + f.anchor.normal[1] * 0.3,
          f.anchor.pos[2] + f.anchor.normal[2] * 0.3
        );
        b.spin.localToWorld(wn);
        const nx = wn.x - wp.x, ny = wn.y - wp.y, nz = wn.z - wp.z;
        const vd = s.v.copy(b.camera.position).sub(wp);
        const facing = (nx * vd.x + ny * vd.y + nz * vd.z) / ((Math.hypot(nx, ny, nz) * vd.length()) || 1);
        const proj = wp.clone().project(b.camera);
        const x = (proj.x * 0.5 + 0.5) * cw, y = (-proj.y * 0.5 + 0.5) * ch;
        const vis = facing > 0.05 && proj.z < 1;
        const op = vis ? Math.min(1, (facing - 0.05) * 3) : 0;
        f.el.style.opacity = op.toFixed(2);
        f.el.style.pointerEvents = (vis && op > 0.3) ? 'auto' : 'none';
        f.el.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
      }
    }

    wireControls() {
      this.controls = this.closest('[data-tt-root]') || this.parentElement;
      const root = this.controls || document;
      root.querySelectorAll('[data-tt-auto]').forEach((btn) => btn.addEventListener('click', () => {
        this.auto = !this.auto;
        const v = btn.querySelector('.v'); if (v) v.textContent = this.auto ? 'aan' : 'uit';
        btn.classList.toggle('is-active', this.auto);
      }));
      root.querySelectorAll('[data-tt-bg]').forEach((btn) => btn.addEventListener('click', () => {
        this.bg = this.bg === 'dark' ? 'light' : 'dark';
        this.built && this.built.setBackground(this.bg);
        this.controls && this.controls.classList.toggle('is-light', this.bg === 'light');
        const v = btn.querySelector('.v'); if (v) v.textContent = this.bg === 'light' ? 'licht' : 'donker';
      }));
      root.querySelectorAll('[data-tt-finish]').forEach((btn) => btn.addEventListener('click', () => {
        this.finish = btn.getAttribute('data-tt-finish');
        this.built && this.built.setFinish(this.finish);
        root.querySelectorAll('[data-tt-finish]').forEach((b) => b.classList.toggle('is-active', b === btn));
      }));
      root.querySelectorAll('[data-tt-features]').forEach((btn) => btn.addEventListener('click', () => {
        this.featOn = !this.featOn;
        const v = btn.querySelector('.v'); if (v) v.textContent = this.featOn ? 'aan' : 'uit';
        btn.classList.toggle('is-active', this.featOn);
        if (this.hotLayer) this.hotLayer.style.display = this.featOn ? '' : 'none';
        if (!this.featOn) this.#closeCard();
      }));
    }

    syncControlState() {
      const root = this.controls || this;
      this.controls && this.controls.classList.toggle('is-light', this.bg === 'light');
      root.querySelectorAll('[data-tt-finish]').forEach((b) => b.classList.toggle('is-active', b.getAttribute('data-tt-finish') === this.finish));
      root.querySelectorAll('[data-tt-auto] .v').forEach((v) => v.textContent = this.auto ? 'aan' : 'uit');
      root.querySelectorAll('[data-tt-features] .v').forEach((v) => v.textContent = this.featOn ? 'aan' : 'uit');
    }

    fail() {
      this.setAttribute('data-failed', '');
      this.#hideLoader();
      const root = this.controls || this.parentElement || this;
      if (root && root.querySelector && !root.querySelector('.rince-tt__fallback')) {
        const msg = document.createElement('div');
        msg.className = 'rince-tt__fallback';
        msg.textContent = '3D-weergave kon niet laden. Vernieuw de pagina of probeer een andere browser.';
        msg.setAttribute('style', 'position:absolute;inset:0;z-index:4;display:flex;align-items:center;justify-content:center;text-align:center;padding:0 24px;font:300 13px/1.5 Sora,system-ui,sans-serif;letter-spacing:.03em;color:rgba(255,255,255,.6)');
        root.appendChild(msg);
      }
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.raf);
      this.#disarmInit();
      this.visObserver && this.visObserver.disconnect();
      this.ro && this.ro.disconnect();
      try { this.built && this.built.dispose && this.built.dispose(); } catch (e) {}
      try { this.renderer && this.renderer.dispose && this.renderer.dispose(); } catch (e) {}
    }
  }

  if (!customElements.get('rince-turntable')) customElements.define('rince-turntable', RinceTurntable);
})();
